// extracted by mini-css-extract-plugin
export var container = "styles-module--container--7Bc+5";
export var slides = "styles-module--slides--oEld0";
export var scrollLeftBtn = "styles-module--scrollLeftBtn--hasve";
export var scrollRightBtn = "styles-module--scrollRightBtn--UBnjW";